const VASCO_GTM_ID = 'GTM-K7BQ399L'

export function injectVascoGoogleTagManager(gtmId = VASCO_GTM_ID) {
  if (typeof document === 'undefined' || !gtmId) return
  if (document.querySelector(`script[data-gtm-id="${gtmId}"]`)) return

  const script = document.createElement('script')
  script.setAttribute('data-gtm-id', gtmId)
  script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`
  document.head.appendChild(script)
}

export function maybeInjectGoogleTagManagerForOwner(ownerId) {
  if (String(ownerId) === '297') {
    injectVascoGoogleTagManager()
  }
}
